import React from 'react'
import {NavLink } from 'react-router'
import { useCart } from 'react-use-cart'
function Navbar() {
    const {totalItems} = useCart();
  return (
    <div>
        {/* <!-- Navbar Start --> */}
    <nav className="navbar navbar-expand-lg bg-white navbar-light shadow sticky-top p-0">
        <NavLink to="index.html" className="navbar-brand d-flex align-items-center px-4 px-lg-5">
            <h2 className="m-0 text-primary"><i className="fa fa-car me-3"></i>CarServ</h2>
        </NavLink>
        <button type="button" className="navbar-toggler me-4" data-bs-toggle="collapse" data-bs-target="#navbarCollapse">
            <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarCollapse">
            <div className="navbar-nav ms-auto p-4 p-lg-0">
                <NavLink to="/" className="nav-item nav-link active">Home</NavLink>
                <NavLink to="/about" className="nav-item nav-link">about</NavLink>
                <NavLink to="/service" className="nav-item nav-link">Services</NavLink>
                <NavLink to="/testimonial" className="nav-item nav-link">Testimonial</NavLink>
                <div className="nav-item dropdown">
                    <NavLink to="/pages" className="nav-link dropdown-toggle" data-bs-toggle="dropdown">Pages</NavLink>
                    <div className="dropdown-menu fade-up m-0">
                        <NavLink to="/booking" className="dropdown-item">Booking</NavLink>
                        <NavLink to="/technicians" className="dropdown-item">Technicians</NavLink>
                    </div>
                </div>
                <NavLink to="/contact" className="nav-item nav-link">Contact</NavLink>
                <NavLink to="/products" className="nav-item nav-link">Products</NavLink>
                <NavLink to="/shop" className="nav-item nav-link">Shop</NavLink>
            </div>
            <a href="/cart" class="btn btn-primary py-4 px-lg-5 d-none d-lg-block file"><i class="fa-solid fa-cart-shopping"></i> Cart ({totalItems})</a>
        </div>
    </nav>
    {/* <!-- Navbar End --> */}

    </div>
  )
}
export default Navbar




// dropdown-toggle